export default "__VITE_ASSET__70ed40b8__"